import {getSisDateAsISO} from "util/SisDateTime";
import React from "react";
import _ from 'lodash';
import {cssInfoList} from 'module/PersonInfo/style/InfoListStyle';
import {getVlErrorCid} from 'module/PersonInfo/util/vlErrorMapper';
import {VlFehl} from 'generated/JavaTOmodifications'
import {VlFehlTO} from 'generated/JavaTO'


interface Props {
	models: (VlFehl | VlFehlTO)[]
}

export function VlErrorList({models}: Props) {
	const grouped = _.groupBy(models, 'datum');
	return (
		<div css={cssInfoList.root}>
			<table>
				<tbody>
				{_.map(grouped, (errors, date) => (
					<tr key={date}>
						<td css={cssInfoList.date}>{`${getSisDateAsISO(date)} - `}</td>
						<td>
							{errors.map(model => <div key={(model as VlFehl).cid || getVlErrorCid(model as VlFehlTO)} css={cssInfoList.msg}>{model.fehlerText}</div>)}
						</td>
					</tr>
				))
				}
				</tbody>
			</table>
		</div>
	);
}
